import { render, staticRenderFns } from "./CoOwnersCard.vue?vue&type=template&id=591a0005&"
import script from "./CoOwnersCard.vue?vue&type=script&lang=js&"
export * from "./CoOwnersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports